import React, { useEffect } from "react";
import "./styles.css";
import Nav from "./Nav";
import Hero from "./Hero";
import { Marquee, Features, HowItWorks, Testimonials, About, CTA, Footer } from "./Sections";
import {
  Aurora, MeshBackdrop, Spotlight, CustomCursor,
  ScrollProgress, MatchToasts, useReveal, useHeartTrail,
} from "./Effects";

export default function Landing() {
  useReveal();
  useHeartTrail();

  useEffect(() => {
    document.body.classList.add("landing-active");
    return () => document.body.classList.remove("landing-active");
  }, []);

  return (
    <div className="landing">
      <Aurora />
      <MeshBackdrop />
      <Spotlight />
      <CustomCursor />
      <ScrollProgress />
      <MatchToasts />
      <div className="grid-overlay" />
      <div className="noise" />

      <Nav />
      <Hero />
      <Marquee />
      <Features />
      <HowItWorks />
      <Testimonials />
      <About />
      <CTA />
      <Footer />
    </div>
  );
}
